export { default } from './SetPasswordModal.component';
